import type Pubsub from '../pubsub';
import { pubsubEvents } from '../pubsub';

import { handleAddDraft } from './createDraftPostMessage';
import { handlePublishPost } from './publishPostMessage';
import { handleCreateTeam } from './createTeamMessage';
import { handleCreateMember } from './createMemberMessage';
import { handleDeleteMember } from './deleteMemberMessage';
import { handleUpdateTeam } from './updateTeamMessage';
import { handleUpdatePost } from './updatePostMessage';
import { handleCreateChannel } from './createChannelMessage';
import { handleUpdateChannel } from './updateChannelMessage';
import { handleUserChannels } from './updateUserMessage';
import { handleClientAdminAccess } from './clientAdminAccess';
import { handleUpdateClientAdminAccess } from './editClientAdmins';
import { handleStudyContacts } from './studyContactMessage';
import { handleSendInviteToUser } from './inviteMember';

export const DEBUG: boolean = false as const;

export const GLOBAL_MESSAGE_EVENT = 'toast-global-message' as const;

type PusherSocket = unknown; // not really relevant, we don't use this Socket info anywhere

export type PayloadDataType<T> = [PusherSocket, T];

export function handlePusherMessages(pubsub: Pubsub) {
  pubsub
    .subscription(pubsubEvents.CHANNEL_ACCESS_GRANTED, handleUserChannels)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.CHANNEL_ACCESS_REMOVED, handleUserChannels)
    .subscribe();
  pubsub.subscription(pubsubEvents.ADD_DRAFT, handleAddDraft).subscribe();
  pubsub.subscription(pubsubEvents.PUBLISH_POST, handlePublishPost).subscribe();
  pubsub.subscription(pubsubEvents.UPDATE_POST, handleUpdatePost).subscribe();
  pubsub.subscription(pubsubEvents.CREATE_TEAM, handleCreateTeam).subscribe();
  pubsub.subscription(pubsubEvents.UPDATE_TEAM, handleUpdateTeam).subscribe();
  pubsub
    .subscription(
      pubsubEvents.UPDATE_CLIENT_ADMINS,
      handleUpdateClientAdminAccess
    )
    .subscribe();
  pubsub
    .subscription(pubsubEvents.ADD_CLIENT_ADMIN, handleUpdateClientAdminAccess)
    .subscribe();

  pubsub
    .subscription(
      pubsubEvents.DELETE_CLIENT_ADMIN,
      handleUpdateClientAdminAccess
    )
    .subscribe();
  pubsub
    .subscription(
      pubsubEvents.CLIENT_ADMIN_ACCESS_GRANTED,
      handleClientAdminAccess
    )
    .subscribe();
  pubsub
    .subscription(
      pubsubEvents.CLIENT_ADMIN_ACCESS_REMOVED,
      handleClientAdminAccess
    )
    .subscribe();

  pubsub
    .subscription(pubsubEvents.CREATE_MEMBER, handleCreateMember)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.DELETE_MEMBER, handleDeleteMember)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.CREATE_CHANNEL, handleCreateChannel)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.UPDATE_CHANNEL, handleUpdateChannel)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.STUDY_CONTACT_CONFIG_ADDED, handleStudyContacts)
    .subscribe();
  pubsub
    .subscription(
      pubsubEvents.STUDY_CONTACT_CONFIG_UPDATED,
      handleStudyContacts
    )
    .subscribe();
  pubsub
    .subscription(
      pubsubEvents.STUDY_CONTACT_CONFIG_REMOVED,
      handleStudyContacts
    )
    .subscribe();
  pubsub
    .subscription(pubsubEvents.TEAM_CONTACT_ADDED, handleStudyContacts)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.TEAM_CONTACT_UPDATED, handleStudyContacts)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.TEAM_CONTACT_DELETED, handleStudyContacts)
    .subscribe();
  pubsub
    .subscription(pubsubEvents.INVITE_CREATED, handleSendInviteToUser)
    .subscribe();
}
